import script from "./ChatTicketsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatTicketsModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatTicketsModal.vue?vue&type=style&index=0&id=53c4da31&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53c4da31"]])

export default __exports__